import React from 'react';
import { Radar, RadarChart as RechartsRadar, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Legend, Tooltip } from 'recharts';

const RadarChart = ({ data, buildings }) => {
  const colors = ['#1E40AF', '#0F766E', '#DC2626', '#D97706'];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-popover border border-border rounded-lg p-3 shadow-lg">
          <p className="text-sm font-semibold text-foreground mb-2">{payload?.[0]?.payload?.dimension}</p>
          {payload?.map((entry, index) => (
            <div key={index} className="flex items-center justify-between gap-4">
              <span className="caption text-muted-foreground">{entry?.name}:</span>
              <span className="text-sm font-semibold data-text" style={{ color: entry?.color }}>
                {entry?.value}%
              </span>
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6">
      <div className="mb-4">
        <h3 className="text-base md:text-lg font-semibold text-foreground mb-1">Performance Radar</h3>
        <p className="caption text-muted-foreground">Multi-dimensional building performance comparison</p>
      </div>
      <div className="w-full h-64 md:h-80 lg:h-96" aria-label="Building Performance Radar Chart">
        <ResponsiveContainer width="100%" height="100%">
          <RechartsRadar data={data}>
            <PolarGrid stroke="var(--color-border)" />
            <PolarAngleAxis
              dataKey="dimension"
              tick={{ fill: 'var(--color-muted-foreground)', fontSize: 12 }}
            />
            <PolarRadiusAxis
              angle={90}
              domain={[0, 100]}
              tick={{ fill: 'var(--color-muted-foreground)', fontSize: 10 }}
            />
            {buildings?.map((building, index) => (
              <Radar
                key={building?.id}
                name={building?.name}
                dataKey={building?.id}
                stroke={colors?.[index % colors?.length]}
                fill={colors?.[index % colors?.length]}
                fillOpacity={0.2}
                strokeWidth={2}
              />
            ))}
            <Tooltip content={<CustomTooltip />} />
            <Legend
              wrapperStyle={{ paddingTop: '20px' }}
              iconType="circle"
            />
          </RechartsRadar>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default RadarChart;